import React, { useEffect, useMemo, useRef, useState } from "react";
import { EditorState } from "draft-js";
import EditorBox from "features/Bookmarks/components/Editor";
import { Box, Alert, Skeleton } from "@mui/material";
import { marked } from "marked";
import { stateFromHTML } from "draft-js-import-html";
import { stateToMarkdown } from "draft-js-export-markdown";

const CollectionNotes = ({
  markdownSummary,
  setMarkdownSummary,
  saveCollectionFolder,
  handleCollectionOverview,
}) => {
  // const location = useLocation();
  const [htmlSummary, sethtmlSummary] = useState(null);
  const [error, setError] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const [initialized, setInitialized] = useState(false);
  const changingTimeout = useRef(null);

  function markdownToContentState(markdown) {
    const html = marked(markdown != null ? markdown : "");
    return stateFromHTML(html);
  }

  function getMarkdown(editorState) {
    const contentState = editorState.getCurrentContent();
    const markdown = stateToMarkdown(contentState);
    return markdown;
  }

  const hasChanges = useMemo(() => {
    if (htmlSummary == null) {
      return false;
    }
    return (
      JSON.stringify(getMarkdown(htmlSummary)) !==
      JSON.stringify(markdownSummary)
    );
  }, [htmlSummary, markdownSummary]);

  // const unsaved =
  //   hasChanges() && location.pathname.includes("collection-notes");
  //useSaveOnRouteChange(saveCollectionFolder, unsaved, getMarkdown);

  function handleContentChange() {
    if (changingTimeout.current != null) {
      clearTimeout(changingTimeout.current);
    }
    changingTimeout.current = setTimeout(async () => {
      await handleSave();
    }, 1000 * 1.5);
  }

  async function handleSave(showToastr = false) {
    if (!hasChanges || error || !initialized) {
      return;
    }
    const markdown = getMarkdown(htmlSummary);

    setIsSaving(true);
    try {
      await saveCollectionFolder(markdown, showToastr);
      setMarkdownSummary(markdown);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSaving(false);
    }
  }

  useEffect(() => {
    if (
      htmlSummary == null ||
      JSON.stringify(markdownSummary) !==
        JSON.stringify(getMarkdown(htmlSummary))
    ) {
      const contentState = markdownToContentState(markdownSummary);
      const initialEditorState = EditorState.createWithContent(contentState);
      // const editorStateAtEnd = EditorState.moveFocusToEnd(initialEditorState);
      sethtmlSummary(initialEditorState);
    }
  }, [markdownSummary]);

  useEffect(() => {
    if (htmlSummary == null) {
      return;
    }
    const markdown = getMarkdown(htmlSummary);
    if (markdown.length > 50000) {
      setError(true);
    } else {
      setError(false);
    }
  }, [htmlSummary]);

  useEffect(() => {
    async function fetchData() {
      try {
        await handleCollectionOverview();
      } catch (e) {
        console.error(e);
      } finally {
        setInitialized(true);
      }
    }
    fetchData();
  }, []);

  // useEffect(() => {
  //   const intervalId = setInterval(async () => {
  //     console.log({
  //       hasChanges: hasChanges(),
  //       isChanging,
  //       isSaving,
  //       htmlSummary: htmlSummary == null,
  //     });
  //     if (htmlSummary == null) {
  //       return;
  //     }
  //     try {
  //       await handleSave();
  //     } catch (error) {
  //       console.error("Error auto-saving:", error);
  //     } finally {
  //       setIsSaving(false);
  //     }
  //   }, 3000);
  //   return () => clearInterval(intervalId);
  // }, [htmlSummary]);

  return (
    <Box sx={{ mb: 10, mt: 2 }}>
      {error && (
        <Alert severity="error" sx={{ width: "fit-content", px: 4, mb: 2 }}>
          Character limit of 50,000 exceeded. Please reduce your input length.{" "}
        </Alert>
      )}
      {initialized ? (
        <EditorBox
          summaryEditor={true}
          isFocused={true}
          setIsFocused={() => {}}
          editorState={htmlSummary}
          setEditorState={sethtmlSummary}
          handleSave={() => {}}
          handleBlur={() => {}}
          fromSummary={true}
          isBlur={true}
          onEnterSave={false}
          shouldSave={hasChanges}
          showSaveIcon={true}
          placeholder="Type your collection notes here."
          isSaving={isSaving}
          handleContentChange={handleContentChange}
        />
      ) : (
        <Skeleton
          variant="rounded"
          width="100%"
          sx={{ aspectRatio: 16 / 9, height: "unset" }}
        />
      )}
    </Box>
  );
};

export default CollectionNotes;
